
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/second-year-law-what-changes",
      function () {
        return require("private-next-pages/resources/second-year-law-what-changes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/second-year-law-what-changes"])
      });
    }
  